<template>
    <auction-category-select v-if="isLoaded" v-model="category" v-bind="{ ...attrs_input, categories, md }" returnObject clearable rowClass="ma-n2 pa-2" colClass="pa-2" cols="12" sm="12" @input="emit" />
</template>

<script>
import api from "@/api";
import { attrs_input, AUCTION_CATEGORY_GROUPS, WORK_AUCTION_MODES } from "@/assets/variables";

import AuctionCategorySelect from "./categories/auction-category-select.vue";

export default {
    components: {
        AuctionCategorySelect,
    },
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        category: null,
        categories: [],

        attrs_input,
        isLoaded: false,
    }),
    computed: {
        group() {
            switch (this.value?.mode_auction) {
                case WORK_AUCTION_MODES.PRIVATE.value: {
                    return AUCTION_CATEGORY_GROUPS.PRIVATE.value;
                }
                case WORK_AUCTION_MODES.PERMANENT.value: {
                    return AUCTION_CATEGORY_GROUPS.PERMANENT.value;
                }
                default: {
                    return null;
                }
            }
        },
        md() {
            switch (this.value?.mode_auction) {
                case WORK_AUCTION_MODES.PERMANENT.value: {
                    return 6;
                }
                default: {
                    return 4;
                }
            }
        },
    },
    mounted() {
        this.init();
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        group() {
            this.init();
        },
    },
    methods: {
        sync() {
            this.category = this.value?.category || null;
        },
        emit() {
            const { category } = this;
            this.$emit("input", { ...this.value, category });
        },

        async init() {
            this.isLoaded = false;
            const { group } = this;
            this.categories = (await api.console.auction.categories.gets({ params: { depth: 1, group } }))?.categories || [];
            this.isLoaded = true;
        },
    },
};
</script>

<style></style>
